import { TranslationObject } from '../i18n/translation';

const namespace = 'practicetypes.uha';
const translations: TranslationObject = {
  title: {
    id: `${namespace}.title`,
    nb: 'Administrering av praksistyper og aktivitetskrav',
    en: 'Administer practice types and requirements',
  },
  subtitle: {
    id: `${namespace}.subtitle`,
    nb: 'Opprett og rediger aktivitetskrav',
    en: 'Create and edit activity requirements',
  },
  nameHeader: {
    id: `${namespace}.nameHeader`,
    nb: 'Praksistypenavn',
    en: 'Practice type name',
  },
  action: {
    id: `${namespace}.action`,
    nb: 'Handling',
    en: 'Action',
  },
  createRequirement: {
    id: `${namespace}.createRequirement`,
    nb: 'Opprett aktivitetskrav',
    en: 'Create requirements',
  },
  editRequirements: {
    id: `${namespace}.editRequirements`,
    nb: 'Endre aktivitetskrav',
    en: 'Edit requirements',
  },
  seeRequirements: {
    id: `${namespace}.seeRequirements`,
    nb: 'Se aktivitetskrav',
    en: 'See requirements',
  },
  places: {
    id: `${namespace}.places`,
    nb: 'Steder',
    en: 'Places',
  },
  lastChange: {
    id: `${namespace}.lastChange`,
    nb: 'Sist endret',
    en: 'Last change',
  },
  practiceIn: {
    id: `${namespace}.practiceIn`,
    nb: 'Praksis i {place}',
    en: 'Practice in {place}',
  },
  back: {
    id: `${namespace}.back`,
    nb: 'Til min institusjon',
    en: 'To my institution',
  },
  withRequirements: {
    id: `${namespace}.withRequirements`,
    nb: 'Praksistyper med aktivitetskrav',
    en: 'Practice types with requirements',
  },
  withoutRequirements: {
    id: `${namespace}.withoutRequirements`,
    nb: 'Praksistyper uten aktivitetskrav',
    en: 'Practice types without requirements',
  },
};

export default translations;
